import { Suspense, type ComponentType, type LazyExoticComponent } from 'react';

function RouteLoading() {
  return (
    <div className="min-h-screen bg-[#f9f7f3] flex items-center justify-center px-6">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-4 rounded-full border-2 border-slate-200 border-t-teal-500 animate-spin" />
        <p className="text-sm text-slate-500">Loading Zobu Consulting…</p>
      </div>
    </div>
  );
}

export default function LazyRouteElement({
  Component,
}: {
  Component: LazyExoticComponent<ComponentType>;
}) {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Component />
    </Suspense>
  );
}
